import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { NegativeButton } from 'components/ui/negativeButton'
import { ShowAlertDialogParams, useAlertDialogDispatcher } from 'context/ui/alertDialog'
import { TopMySpotItemFragment } from 'generated/graphql'
import { FC, useState } from 'react'

type Spot = Pick<TopMySpotItemFragment, 'id' | 'title'>

type Params = {
  spot: Spot
  onConfirm: (spot: Spot) => Promise<boolean>
}

export const buildConfirmDeleteMySpotModal = (params: Params): ShowAlertDialogParams => ({
  size: '2xl',
  header: 'マイスポットの削除',
  hideCloseButton: true,
  body: <ConfirmDeleteMySpotModalBody {...params} />,
})

const ConfirmDeleteMySpotModalBody: FC<Params> = ({ spot, onConfirm }) => {
  const { hideAlertDialog } = useAlertDialogDispatcher()
  const [deleting, setDeleting] = useState(false)

  const onDelete = async () => {
    setDeleting(true)
    try {
      const succeeded = await onConfirm(spot)
      if (succeeded) hideAlertDialog()
    } finally {
      setDeleting(false)
    }
  }

  return (
    <Box px="48px" py="32px">
      <Text textAlign="center">
        以下のマイスポットを削除します。
        <br />
        削除したマイスポットは復元できません。よろしいですか？
      </Text>
      <Box mt="32px" p="24px" borderWidth="1px" borderColor="gray.200" borderRadius="6px">
        <Text fontSize="18px" fontWeight="bold" textAlign="center" wordBreak="break-all">
          {spot.title}
        </Text>
      </Box>
      <HStack spacing="28px" mt="64px" mx="auto" w="380px">
        <NegativeButton flex={1} isDisabled={deleting} onClick={hideAlertDialog}>
          戻る
        </NegativeButton>
        <Button flex={1} colorScheme="red" isLoading={deleting} onClick={onDelete}>
          削除する
        </Button>
      </HStack>
    </Box>
  )
}
